import React from "react";

interface ListSvgProps {
  active: boolean;
}

export default function ListSvg({ active }: ListSvgProps): React.JSX.Element {
  return (
    <svg
      fill="#000000"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="30px"
      height="30px"
      stroke="#000000"
      strokeWidth="0.00512"
      className={`${active ? "[fill-[#0097ab]" : ""}`}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />

      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

      <g id="SVGRepo_iconCarrier" className={`${active ? "fill-[#0097ab]" : ""}`}>
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <rect x="163.136" y="68.008" width="186.064" height="16" />{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <rect x="163.136" y="115.384" width="348.864" height="16" />{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M0,48.232v102.944h101.36V48.232H0z M85.36,135.16H16V64.232h69.36V135.16z" />{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <rect x="163.136" y="224.312" width="186.064" height="16" />{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <rect x="163.136" y="271.672" width="348.864" height="16" />{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M0,204.52v102.944h101.36V204.52H0z M85.36,291.464H16V220.52h69.36V291.464z" />{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <rect x="163.136" y="380.6" width="186.064" height="16" />{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <rect x="163.136" y="427.976" width="348.864" height="16" />{" "}
          </g>{" "}
        </g>{" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M0,360.824v102.944h101.36V360.824H0z M85.36,447.752H16v-70.944h69.36V447.752z" />{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
}
